module.exports = __webpack_public_path__ + "img/send-02.9ff0e9e3.svg";